<div class="frame-in">
  <div class="items south-america-1-frame">
    <svg class="road south-america-1">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <defs>
    <filter filterUnits="userSpaceOnUse" id="Filter_0" x="3.5px" y="427.5px" width="222px" height="116px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_1" x="-2.5px" y="260.5px" width="105px" height="154px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_2" x="123.5px" y="129.5px" width="113px" height="159px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_3" x="109.5px" y="68.5px" width="106px" height="48px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_4" x="10.5px" y="-2.5px" width="78px" height="104px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>
  <g filter="url(#Filter_0)">
    <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
      d="M13.545,435.572 C13.545,435.572 16.489,467.83 65.568,460.53 C101.935,454.845 139.992,467.625 172.675,483.515 C205.359,499.404 219.499,530.499 219.499,530.499 " />
    </g>
    <g filter="url(#Filter_1)">
      <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
        d="M94.130,273.381 C94.130,273.381 54.667,264.406 34.966,282.562 C15.265,300.717 28.322,372.195 7.424,403.950 " />
      </g>
      <g filter="url(#Filter_2)">
        <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
          d="M220.618,135.672 C220.618,135.672 228.662,146.409 230.819,191.776 C232.976,237.143 216.831,286.727 130.852,278.482 " />
        </g>
        <g filter="url(#Filter_3)">
          <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
            d="M116.572,80.589 C116.572,80.589 187.336,53.394 211.438,106.90 " />
          </g>
          <g filter="url(#Filter_4)">
            <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
              d="M52.307,7.144 C52.307,7.144 -34.307,79.942 80.869,86.709 " />
            </g>
          </svg>
          <div class="country south-america-1"></div>
          <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 11, 'active': quizLevel === 11 && tick2Quiz}"></div>

          @for (zone of zones; track zone) {
            <div>
              <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
            </div>
          }

          @for (zone of zones; track zone; let i = $index) {
            <div
              class="poi {{zone.class}}"
              [ngClass]="{active: zone.active, 'lock': zone.locked}"
              (mouseenter)="mouseEnter(zone)"
              (mouseleave)="mouseLeave(zone)"
              (click)="selectZone(zone)">
              <span>{{ zone.locked ? '' : zone.number}}</span>
            </div>
          }
        </div>
      </div>

      <img class="frame-title" src="assets/images/zones/south-america-1/title.png">

      <audio id="introductionAudio" (ended)="playBgAudio()">
        <source src="assets/sounds/country.wav" type="audio/wav">
      </audio>
      <audio id="bgAudio" (ended)="playIntroductionAudio()">
        <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
      </audio>

      <div class="footer">
        <ul class="zone-menu">
          <li>
            @if (!haveAccess('4-1')) {
              <span class="lock"></span>
            }
            @if (haveAccess('4-1')) {
              <a class="menu-item" [routerLink]="[ '/game/south-america-1' ]" routerLinkActive="active">1</a>
            }
          </li>
          <li>
            @if (!haveAccess('4-2')) {
              <span class="lock"></span>
            }
            @if (haveAccess('4-2')) {
              <a class="menu-item" [routerLink]="[ '/game/south-america-2' ]" routerLinkActive="active">2</a>
            }
          </li>
          <li>
            @if (!haveAccess('4-3')) {
              <span class="lock"></span>
            }
            @if (haveAccess('4-3')) {
              <a class="menu-item" [routerLink]="[ '/game/south-america-3' ]" routerLinkActive="active">3</a>
            }
          </li>
        </ul>
        <img class="footer-bg" src="assets/images/zones/south-america-1/footer.png">
      </div>

      <audio id="continentHover">
        <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
      </audio>
      <audio id="continentClick">
        <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
      </audio>
